<style scoped>
.img-container {
  padding-top: 75%;
  position: relative;
}

.img-container .img {
  background-color: #f7f7f7;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
<template lang='pug'>
  .col.s6.m4
    router-link(:to='{name: "store", params: { shopCode: shop.code}}')
      div.img-container
        div.img(:style='{backgroundImage: "url(" + shop.photo.small + ")"}')
    p.title.light {{ shop.name }}
    //- p.subtitle sold by {{ product.shop.name }}
    //- p.title.green-text {{ priceRange }}
    .vspace.large
</template>
<script>
export default {
  props: ['shop', 'index']
}
</script>


// WEBPACK FOOTER //
// src/components/app-supplier-card.vue